<ng-container *ngIf="filter.innerFilters">
  <div class="options-wrapper" *ngFor="let innerFilter of filter.innerFilters; trackBy: trackByIndex">
    <div class="flex-wrapper-checkbox" *ngFor="let filterOption of innerFilter.values;let i=index; trackBy: trackByIndex"
         [ngClass]="{'gray':filterOption.recordCount===0,'active':filterOption.selected}"
         (click)="toggleSelected(filterOption, innerFilter)">
      <input type="checkbox" class="primary-checkbox" [(ngModel)]="filterOption.selected">
      <span class="checkmark"></span>
      <span class="option">{{ filterOption.value}} <span class="count">({{filterOption.recordCount}})</span></span>
    </div>
  </div>
</ng-container>
<div class="fields-wrapper">
  <div class="field">
    <input class="input" #min [ngModel]="filter.selectedInterval.min" (blur)="onSelectedMinimumChange(min.value)">
    <span *ngIf="filter.unit" [innerHTML]="filter.unit"></span>
  </div>
  <div class="separator"><img src="/assets/icons/minus.svg"/></div>
  <div class="field">
    <input class="input " #max [ngModel]="filter.selectedInterval.max" (blur)="onSelectedMaximumChange(max.value)">
    <span *ngIf="filter.unit" [innerHTML]="filter.unit"></span>
  </div>
</div>
<div class="slider-wrapper-noui" #slider></div>
